import { CompletionStat } from './completion-group-rate';

export class GroupCompletionRateStats {
  assessmentName: string;
  completionStatsDTO: CompletionStat;

  constructor(assessmentName: string, completionStatsDTO: CompletionStat) {
    this.assessmentName = assessmentName;
    this.completionStatsDTO = completionStatsDTO;
  }
}
